import { useTranslation } from 'react-i18next';

import { Col, Row, Space, Divider, Dropdown, Typography, Tooltip } from 'antd';

import Awareness from 'assets/images/footer/Awareness.svg';
import Container from 'components/container';
import { Link } from 'react-router-dom';
import { isLocaleEnglish } from 'utils/languageUtils';

import { LogoRow, StyledFooter, SectionHead, Section } from './styledComponents';
import { useKeycloakReady } from 'hooks';

import GooglePlay from 'assets/images/footer/GooglePlay.svg';
import FB from 'assets/images/footer/FB.svg';
import IG from 'assets/images/footer/IG.svg';
import Linkedin from 'assets/images/footer/Linkedin.svg';
import Wechat from 'assets/images/footer/Wechat.svg';
import Youtube from 'assets/images/footer/Youtube.svg';
import Appstore from 'assets/images/footer/Appstore.svg';
import qrCode from 'assets/images/footer/wechat_qr.jpg';

import { HelpMenu } from '../../BravoHeader/components';
const GreyFooter = (): JSX.Element => {
  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);
  const menuItems = ['home', 'claims', 'benefits', 'documents', 'help'];
  const menuItems2 = ['LIHome', 'LIPolicies', 'LIPayment', 'LIPolicyUp', 'LISupport'];
  const { keycloak, tokenParsed } = useKeycloakReady();
  const isLogin =
    keycloak.authenticated &&
    !['/we-care-login', '/register/otp-verification', '/migration', '/login'].includes(location?.pathname);
  const WcTooltips = () => {
    return (
      <div
        className="wc-tooltip"
        style={{
          textAlign: 'center',
          whiteSpace: 'nowrap',
          fontFamily: 'Roboto400',
          fontSize: '15px',
        }}
      >
        <p style={{ marginBottom: 0, lineHeight: '22px' }}>{t('footer.wctooltip1')}</p>
        <p style={{ marginBottom: 0, lineHeight: '22px' }}>{t('footer.wctooltip2')}</p>
        <img src={qrCode} />
      </div>
    );
  };
  return (
    <StyledFooter>
      <Container style={{ marginLeft: 'auto', marginRight: 'auto', maxWidth: '1384px' }} pathFlag={true}>
        <LogoRow>
          <Col>
            <img src={Awareness} alt="footer logo" />
          </Col>
        </LogoRow>
        {isLogin && (
          <>
            <Row>
              {tokenParsed?.ebClientKey !== '' && (
                <Col span={10} style={{ marginBottom: '12px' }}>
                  <Section>
                    <SectionHead style={{ fontSize: '17px', fontFamily: 'Roboto500 !important;' }} strong>
                      {t('life.guide.ebnav')}
                    </SectionHead>
                    <Space direction="horizontal" size={[40, 'small']} wrap>
                      <Row>
                        {menuItems.map((item1, index) => {
                          return item1 === 'help' ? (
                            <Col span={24} style={{ marginBottom: '12px' }} key={index}>
                              <Dropdown overlay={<HelpMenu />} trigger={['click']}>
                                <Typography.Link>
                                  <div style={{ color: '#FFFFFF', fontSize: '15px' }}>
                                    <span className="font-set">{t('header.help')}</span>
                                  </div>
                                </Typography.Link>
                              </Dropdown>
                            </Col>
                          ) : (
                            <Col span={24} style={{ marginBottom: '12px' }} key={index}>
                              <Link to={`/${item1}`}>
                                <div style={{ color: '#FFFFFF', fontSize: '15px' }}>
                                  <span className="font-set">{t(`header.${item1}`)}</span>
                                </div>
                              </Link>
                            </Col>
                          );
                        })}
                      </Row>
                    </Space>
                  </Section>
                </Col>
              )}
              {tokenParsed?.ilClientKey !== '' && (
                <Col span={10} offset={tokenParsed?.ebClientKey !== '' ? 2 : 0} style={{ marginBottom: '12px' }}>
                  <Section>
                    <SectionHead strong style={{ fontSize: '17px', fontFamily: 'Roboto500 !important;' }}>
                      {t('life.guide.linav')}
                    </SectionHead>
                    <Space direction="horizontal" size={[40, 'small']} wrap>
                      <Row>
                        {menuItems2.map((item2, index) => {
                          return (
                            <Col span={24} style={{ marginBottom: '12px' }} key={index + 'life'}>
                              <Link to={`/${item2}`}>
                                <div style={{ color: '#FFFFFF', fontSize: '15px' }}>
                                  <span className="font-set">{t(`header.${item2}`)}</span>
                                </div>
                              </Link>
                            </Col>
                          );
                        })}
                      </Row>
                    </Space>
                  </Section>
                </Col>
              )}
            </Row>
            <Divider style={{ borderColor: '#fff', marginTop: '12px' }}></Divider>
          </>
        )}
        <Row justify="space-between" style={{ width: '100%' }}>
          <Col lg={10} md={10} sm={24} style={{ marginBottom: '7px' }}>
            <Section>
              <SectionHead strong style={{ fontSize: '17px', fontFamily: 'Roboto500 !important;' }}>
                {t('footer.follow')}
              </SectionHead>
              <Space direction="horizontal" size={[30, 'small']} wrap align="center">
                {/* <Space direction="horizontal"> */}
                <Typography.Link href="https://www.facebook.com/GeneraliHongKong" target="_blank">
                  <img src={FB} alt="" />
                </Typography.Link>
                <Typography.Link
                  href="https://www.instagram.com/accounts/login/?next=https%3A%2F%2Fwww.instagram.com%2Fgeneralihongkong%2F&is_from_rle"
                  target="_blank"
                >
                  <img src={IG} alt="" />
                </Typography.Link>
                <Typography.Link href="https://hk.linkedin.com/company/generali-hong-kong" target="_blank">
                  <img src={Linkedin} alt="" />
                </Typography.Link>
                <Tooltip
                  title={<WcTooltips />}
                  placement="bottom"
                  style={{ backgroundColor: 'rgba(97,97,97,.9)', textAlign: 'center' }}
                >
                  <img src={Wechat} alt="" style={{ cursor: 'pointer' }} />
                </Tooltip>
                <Typography.Link href="https://www.youtube.com/@generalihongkong" target="_blank">
                  <img src={Youtube} alt="" />
                </Typography.Link>
                {/* </Space> */}
              </Space>
            </Section>
          </Col>
          <Col lg={10} md={10} sm={24} style={{ marginBottom: '7px' }}>
            <Section>
              <SectionHead strong style={{ fontSize: '17px', fontFamily: 'Roboto500 !important;' }}>
                {t('footer.download')}
              </SectionHead>
              <Space direction="horizontal" size={[40, 'small']} wrap>
                <Typography.Link
                  href={
                    isEnglish
                      ? 'https://apps.apple.com/hk/app/generali-genbravo/id1607457003?l=en-GB'
                      : 'https://apps.apple.com/hk/app/generali-genbravo/id1607457003?l=zh'
                    // 'https://apps.apple.com/hk/app/generali-genbravo/id1607457003'
                  }
                >
                  <img src={Appstore} alt="" />
                </Typography.Link>
                <Typography.Link
                  href={
                    isEnglish
                      ? 'https://play.google.com/store/apps/details?id=com.generali.allinone&hl=en'
                      : 'https://play.google.com/store/apps/details?id=com.generali.allinone&hl=zh-hant'
                    // 'https://play.google.com/store/apps/details?id=com.generali.allinone&hl=en'
                  }
                >
                  <img src={GooglePlay} alt="" />
                </Typography.Link>
              </Space>
            </Section>
          </Col>
        </Row>
      </Container>
    </StyledFooter>
  );
};

export default GreyFooter;
